import React from 'react'
import classnames from 'classnames'
import { component_tool } from '@/tool'
import { QsRadio, QsCheckbox, QsSelect, QsInput, QsTextarea, QsRate } from './components'
const { WizComponent } = component_tool;

const Comp = (props) => {
    const { CompName, index, title, required, tips, ...otherProps } = props
    return (
        <div className={classnames("qs-item", !props.preview? "normal": null)}>
            <div className="qs-item-title">
                <strong>{index + 1}、{ title }</strong>{ required ? <span className="qs-item-required">*</span>: null }
            </div>
            <div className="survey-item-tips">{tips}</div>
            <div className="qs-item-content">
                {
                      !props.preview ? <div className="answer"><CompName { ...otherProps } /></div>: <CompName { ...otherProps } />
                }
            </div>
        </div>
    )
}

export default class CreateQuestion extends WizComponent {

    render() {
        const { preview, questions } = this.props
        const Comps = questions && questions.map((val, index) => {
            let comp = null;
            const otherProps = {
                key: val.id,
                index,
                preview,
                ...val
            }
            switch (val.type) {
                case 0:
                    comp = <Comp CompName = { QsRadio } { ...otherProps } /> //单选题
                    break;
                case 1:
                    comp = <Comp CompName = { QsCheckbox } { ...otherProps } /> //多选题
                    break;
                case 2:
                    comp = <Comp CompName = { QsSelect } { ...otherProps } /> //下拉题
                    break;
                case 3:
                case 4:
                    comp = <Comp CompName = { QsInput } { ...otherProps } /> //填空题 //单行文本题
                    break;
                case 5:
                    comp = <Comp CompName = { QsTextarea } { ...otherProps } /> //多行文本题
                    break;
                case 6:
                    comp = <Comp CompName = { QsRate } { ...otherProps } /> //评分题
                    break;
            }
            return comp
        })

        return (
            <div className="question-content">
                {Comps}
            </div>
        )
    }
}

